export * from './details-modal.styled.default';
